<template>
  <div class="login-page">
    <canvas id="canvas" style="width: 100%; height: 100%;"></canvas>
    <div class="login-wrapper" v-if="switchPageFlag === 1">
      <div class="login-header">
        <img src="/static/imgs/fyzn/fylogo.png" alt="" style="height: 170px">
      </div>
      <div class="login-form">
        <div class="form-group">
          <input type="text" v-model="username" placeholder="请输入账户名">
        </div>
        <div class="form-group">
          <input type="password" v-model="password" placeholder="请输入密码" v-on:keyup.enter="login">
        </div>
        <div class="options">
          <el-checkbox v-model="checked">记住我</el-checkbox>
          <a @click="switchToOtherPage(2)" :class="animatedClass">忘记密码?</a>
        </div>
      </div>
      <div class="login-footer">
        <button @click="login">登&nbsp;录</button>
      </div>
    </div>
    <div class="login-wrapper" v-if="switchPageFlag === 2">
      <div class="login-header">
        <!-- <img src="/static/imgs/001-1_meitu_1.png" style="height: 80px" alt=""><img src="/static/imgs/fengyan/fengyan-name.png" style="height: 50px" alt=""> -->
        <img src="/static/imgs/fyzn/fylogo.png" alt="" style="height: 150px">
      </div>
      <div class="login-form">
        <div class="form-group" style="text-align: center;font-size: 15px;">
          <!--<label >忘记密码</label>-->
        </div>
        <div class="form-group">
          <input type="text" v-model="usernameUpdate" ref="usernameRef" placeholder="请输入账户名">
        </div>
        <div class="form-group">
          <input type="text" v-model="email" ref="emailRef" placeholder="请输入注册邮箱" @change="changeEmail">
        </div>
        <div class="form-group">
          <!--<identifyCode></identifyCode>-->
          <div >
            <sideVerify @success="onSuccess" @fail="onFail" @refresh="onRefresh" style="width: 100%" ref="verifyTemplate"></sideVerify>
          </div>
        </div>
      </div>
      <div class="login-check text right">
        <el-button v-if="isCanBack" @click="switchToOtherPage(1)" size="mini">返&nbsp;回</el-button>
        <el-button :disabled="!isCheck" :style="{'background-color': backGround ,'width': sendBtnWidth}"  @click="sendEmail" type="primary" size="mini" plain>  发&nbsp;送</el-button>
      </div>
    </div>

    <div class="login-wrapper" v-if="switchPageFlag === 3">
      <div class="login-header">
        <!-- <img src="/static/imgs/001-1_meitu_1.png" style="height: 80px" alt=""><img src="/static/imgs/001-1_meitu_2.png" style="height: 50px" alt=""> -->
        <img src="/static/imgs/fyzn/fylogo.png" alt="" style="height: 150px">
      </div>
      <div class="login-form-reset" v-if="suidIsValid">
        <div class="form-group" style="text-align: center;font-size: 15px;">
          <!--<label >忘记密码</label>-->
          <h6>您正在重置<font style="color: red">{{name}}</font>的密码</h6>
        </div>
        <div class="form-group">
          <input type="password" v-model="newPassword" ref="refNewPassword" placeholder="请输入新的密码" @change="changePassword">
        </div>
        <div class="form-group">
          <input type="password" v-model="newPassword2" ref="refNewPassword2" placeholder="请再次输入新密码" @change="changePassword">
        </div>
        <div class="form-group">
          <!--<identifyCode></identifyCode>-->
          <div>
            <sideVerify @success="resetOnSuccess" @fail="onFail" @refresh="resetOnRefresh" style="width: 100%" ref="verifyTemplate"></sideVerify>
          </div>
        </div>
      </div>
      <div class="login-footer text right" v-if="suidIsValid">
        <button  :disabled="!isResetCheck" :style="{'background-color': ResetBckGround}" @click="resetPassword">确认重置</button>
      </div>
      <div class="form-group" style="text-align: center;font-size: 15px;" v-if="!suidIsValid">
        <h6>{{remindMsg}}</h6>
      </div>
      <div class="login-footer text right" v-if="!suidIsValid">
        <button  @click="switchToOtherPage(2)">重置密码</button>
      </div>
    </div>
    <div class="login-wrapper" v-if="switchPageFlag === 4">
      <div class="login-header">
        <img src="/static/imgs/fyzn/fylogo.png" alt="" style="height: 170px">
      </div>
      <div class="login-form">
        <div class="form-group">
          <input :disabled="true" type="text" v-model="phone" placeholder="请输入手机号">
        </div>
        <div class="form-group">
          <input type="text" v-model="authCode" placeholder="请输入验证码" style="width: 60%;">
          <!-- <p v-if="remainingTime > 0" style="width: 38%;">重新获取：{{ remainingTime }}秒</p> -->
          <el-button v-if="remainingTime > 0" type="primary" plain style="width: 38%; position:relative; left: 1%;" disabled>重新获取：{{ remainingTime }}秒</el-button>
          <el-button v-if="remainingTime === 0" type="primary" plain style="width: 38%; position:relative; left: 1%;" @click="getVerify">获取验证码</el-button>
        </div>
      </div>
      <div class="login-footer">
        <button @click="checkVerify">验&nbsp;证</button>
      </div>
    </div>
    <div>
      <el-row style="position: fixed;bottom: 20px; left: 80%;z-index: 1000">
        <a style="color: #bbb;text-decoration: none" href="https://beian.miit.gov.cn" target="_blank"><p>备案号：沪ICP备2020035919号</p></a>
      </el-row>
    </div>
  </div>
</template>
<script>
import identifyCode from './identifyCodeNew';

import sideVerify from './slide-verify';

import messageBox from '../promptBox/messageBox';

import './animated.css';

export default {
  data() {
    return {
      checked: false,
      username: null,
      password: null,
      authorization: null,
      email: null,
      isCheck: false,
      backGround: '#9E9E9E',
      suid: this.$route.query.suid,
      switchPageFlag: (this.$route.query.suid === undefined ? 1 : 3),
      isResetCheck: false,
      ResetBckGround: '#9E9E9E',
      newPassword: null,
      newPassword2: null,
      name: null,
      suidIsValid: true,
      remindMsg: '',
      isCanBack: (this.$route.query.suid === undefined),
      sendBtnWidth: (this.$route.query.suid === undefined ? '125px' : '360px'),
      animatedClass: 'animated tada custom-classes-transition-enter-to',
      usernameUpdate: null,
      authCode: null,
      phone: null,
      showTime: true,
      remainingTime: 0, // 初始倒计时60秒
      timer: null // 计时器
    };
  },
  mounted() {
    this.paint()();
    this.autoLogin();
    this.getUserInfoBySuid();
    this.timing();
  },
  methods: {
    login() {
      const authorization = localStorage.getItem('authorization');
      if (authorization) {
        this.$confirm('您将登出原有账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 情况所有缓存数据
          sessionStorage.clear();
          this.loading = true;
          this.$ajax({
            prompt: true,
            method: 'POST',
            url: '/account/logout'
          }).then(() => {
            localStorage.removeItem('account');
            localStorage.removeItem('permissions');
            localStorage.removeItem('authorization');
            localStorage.removeItem('internationalVersionFlag');
            localStorage.removeItem('languageSelectOptions');
            localStorage.removeItem('languageSelect');
            setTimeout(() => {
              this.loading = false;
              this.$router.push({ 'path': '/' });
              this.$ajax({
                url: '/account/sign-in',
                data: {
                  username: this.username,
                  password: this.password
                }
              }).then((res) => {
                if (res.data.verify) {
                  this.switchPageFlag = 4;
                  this.phone = res.data.phone;
                } else {
                  localStorage.setItem('authorization', res.data.authorization);
                  this.userInfo();
                }
              });
            }, 1000);
          });
        }).then(() => {
          localStorage.removeItem('account');
          localStorage.removeItem('permissions');
          localStorage.removeItem('authorization');
          localStorage.removeItem('internationalVersionFlag');
          localStorage.removeItem('languageSelectOptions');
          localStorage.removeItem('languageSelect');
          this.$router.push({ 'path': '/' });
        });
      } else {
        this.$ajax({
          url: '/account/sign-in',
          data: {
            username: this.username,
            password: this.password
          }
        }).then((res) => {
          if (res.data.verify) {
            this.switchPageFlag = 4;
            this.phone = res.data.phone;
          } else {
            localStorage.setItem('authorization', res.data.authorization);
            this.userInfo();
          }
        });
      }
    },
    sendEmail() {
      this.$ajax({
        url: '/account/sendEmail',
        data: {
          email: this.email, username: this.usernameUpdate
        }
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          // 返回登陆页面
          this.switchToOtherPage(1);
          this.$router.push({ path: '/' });
          // location.href = '/';
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
          this.$refs.verifyTemplate.refresh();
          this.$refs.emailRef.focus();
        }
      });
    },
    userInfo() {
      this.$ajax({
        url: '/account/current'
      }).then((res) => {
        if (res.data.account) {
          const account = res.data.account;
          const accountStr = JSON.stringify(account);
          localStorage.setItem('account', accountStr);
          localStorage.setItem('internationalVersionFlag', account.internationalVersionFlag || '0');

          if (account.internationalVersionFlag === '1' || account.internationalVersionFlag === 1) {
            this.$ajax({
              method: 'GET',
              url: '/dict/list/workLanguage'
            }).then((dictRes) => {
              if (dictRes.data && dictRes.data.length > 0) {
                const currentLang = dictRes.data.find(item => item.modelCode === account.workLanguage);
                const languageSelectOptions = currentLang ? [currentLang] : [];
                languageSelectOptions.push({ modelCode: '0', modelName: '中文' });
                localStorage.setItem('languageSelectOptions', JSON.stringify(languageSelectOptions));
                localStorage.setItem('languageSelect', account.workLanguage || '0');
              }
            }).catch(() => {
              localStorage.setItem('languageSelectOptions', JSON.stringify([{ modelCode: '0', modelName: '中文' }]));
              localStorage.setItem('languageSelect', '0');
            });
          }
        }
        if (res.data.permissions) {
          const permissions = JSON.stringify(res.data.permissions);
          localStorage.setItem('permissions', permissions);
        }
        this.$router.push({ 'path': '/main' });
      });
    },
    autoLogin() {
      const authorization = localStorage.getItem('authorization');
      if (authorization && this.$route.query.suid === undefined) {
        this.$router.push({ 'path': '/main' });
      }
    },
    paint() {
      // 定义画布宽高和生成点的个数
      const WIDTH = window.innerWidth;
      const HEIGHT = window.innerHeight;
      const POINT = 35;
      const canvas = document.getElementById('canvas');
      canvas.width = WIDTH;
      canvas.height = HEIGHT;
      const context = canvas.getContext('2d');
      context.strokeStyle = 'rgba(0, 0, 0, 0.2)';
      context.strokeWidth = 1;
      context.fillStyle = 'rgba(0, 0, 0, .1)';
      let circleArr = [];

      // 线条：开始xy坐标，结束xy坐标，线条透明度
      function Line(x, y, _x, _y, o) {
        this.beginX = x;
        this.beginY = y;
        this.closeX = _x;
        this.closeY = _y;
        this.o = o;
      }

      // 点：圆心xy坐标，半径，每帧移动xy的距离
      function Circle(x, y, r, moveX, moveY) {
        this.x = x;
        this.y = y;
        this.r = r;
        this.moveX = moveX;
        this.moveY = moveY;
      }

      // 生成max和min之间的随机数
      function num(max, _min) {
        const min = _min || 0;
        return Math.floor((Math.random() * (max - (min + 1))) + min);
      }
      // 绘制原点
      function drawCricle(cxt, x, y, r, moveX, moveY) {
        const circle = new Circle(x, y, r, moveX, moveY);
        cxt.beginPath();
        cxt.arc(circle.x, circle.y, circle.r, 0, 2 * Math.PI);
        cxt.closePath();
        cxt.fill();
        return circle;
      }

      // 绘制线条
      function drawLine(cxt, x, y, _x, _y, o) {
        const line = new Line(x, y, _x, _y, o);
        cxt.beginPath();
        cxt.strokeStyle = `rgba(0, 0, 0, ${o})`;
        cxt.moveTo(line.beginX, line.beginY);
        cxt.lineTo(line.closeX, line.closeY);
        cxt.closePath();
        cxt.stroke();
      }

      // 每帧绘制
      function draw() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        for (let i = 0; i < POINT; i += 1) {
          drawCricle(context, circleArr[i].x, circleArr[i].y, circleArr[i].r);
        }
        for (let i = 0; i < POINT; i += 1) {
          for (let j = 0; j < POINT; j += 1) {
            if (i + j < POINT) {
              const A = Math.abs(circleArr[i + j].x - circleArr[i].x);
              const B = Math.abs(circleArr[i + j].y - circleArr[i].y);
              const lineLength = Math.sqrt((A * A) + (B * B));
              const C = ((1 / lineLength) * 7) - 0.009;
              const lineOpacity = C > 0.03 ? 0.03 : C;
              if (lineOpacity > 0) {
                drawLine(context, circleArr[i].x, circleArr[i].y, circleArr[i + j].x, circleArr[i + j].y, lineOpacity);
              }
            }
          }
        }
      }
      // 初始化生成原点
      function init() {
        circleArr = [];
        for (let i = 0; i < POINT; i += 1) {
          circleArr.push(drawCricle(context, num(WIDTH), num(HEIGHT), num(15, 2), num(10, -10) / 40, num(10, -10) / 40));
        }
        draw();
      }
      // 调用执行
      return () => {
        init();
        setInterval(() => {
          for (let i = 0; i < POINT; i += 1) {
            const cir = circleArr[i];
            cir.x += cir.moveX;
            cir.y += cir.moveY;
            if (cir.x > WIDTH) {
              cir.x = 0;
            } else if (cir.x < 0) {
              cir.x = WIDTH;
            }
            if (cir.y > HEIGHT) {
              cir.y = 0;
            } else if (cir.y < 0) {
              cir.y = HEIGHT;
            }
          }
          draw();
        }, 16);
      };
    },
    onSuccess() {
      if (this.usernameUpdate === null || this.usernameUpdate === '') {
        this.$message({
          message: '请输入账户名',
          type: 'error'
        });
        this.$refs.usernameRef.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      // 判断是否输入正确的邮箱地址
      if (this.email == null || this.email === '') {
        this.$message({
          message: '请输入注册邮箱地址',
          type: 'error'
        });
        this.$refs.emailRef.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      const emailRg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (!emailRg.test(this.email)) {
        this.$message({
          message: '请输入正确的邮箱地址',
          type: 'error'
        });
        this.$refs.emailRef.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      this.backGround = '';
      this.isCheck = true;
    },
    onFail() {
    },
    onRefresh() {
      this.backGround = '#9E9E9E';
      this.isCheck = false;
    },
    switchToOtherPage(flag) {
      if (flag === 1) {
        this.switchPageFlag = 1;
        this.isCanBack = true;
        this.sendBtnWidth = '125px';
      } else if (flag === 2) {
        this.email = '';
        this.switchPageFlag = 2;
        this.isCheck = false;
        this.backGround = '#9E9E9E';
      } else if (flag === 3) {
        this.switchPageFlag = 3;
        this.newPassword = '';
        this.newPassword2 = '';
        this.$refs.verifyTemplate.refresh();
      } else {
        this.switchPageFlag = 1;
      }
    },
    judgeIsNullAndRemind(val, msg) {
      if (val === null || val === '') {
        this.$message({
          message: msg,
          type: 'error'
        });
        this.$refs.verifyTemplate.refresh();
        return false;
      }
      return true;
    },
    changeEmail() {
      if (this.isCheck) {
        this.$refs.verifyTemplate.refresh();
      }
    },
    resetOnSuccess() {
      if (!this.judgeIsNullAndRemind(this.newPassword, '请输入新的密码')) {
        this.$refs.refNewPassword.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      if (!this.judgeIsNullAndRemind(this.newPassword2, '请再次输入新的密码')) {
        this.$refs.refNewPassword2.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      if (this.newPassword !== this.newPassword2) {
        this.$message({
          message: '您前后两次输入的密码不一致',
          type: 'error'
        });
        this.$refs.refNewPassword.focus();
        this.$refs.verifyTemplate.refresh();
        return;
      }
      this.isResetCheck = true;
      this.ResetBckGround = '';
    },
    resetOnRefresh() {
      this.isResetCheck = false;
      this.ResetBckGround = '#9E9E9E';
    },
    getUserInfoBySuid() {
      if (this.suid === undefined) {
        return;
      }
      this.$ajax({
        url: '/account/getUserInfoBySuid',
        data: {
          suid: this.suid
        }
      }).then((res) => {
        if (res.code === 200) {
          this.name = res.data;
          this.suidIsValid = true;
        } else {
          this.switchToOtherPage(2);
          this.$message({
            message: res.msg,
            type: 'error'
          });
          this.suidIsValid = false;
        }
      });
    },
    resetPassword() {
      this.isResetCheck = false;
      this.ResetBckGround = '#9E9E9E';
      this.$ajax({
        url: '/account/resetPassword',
        data: {
          suid: this.suid,
          password: this.newPassword
        }
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.switchToOtherPage(1);
          this.$router.push({ path: '/' });
          // location.href = '/';
        } else if (res.code === 601) {
          this.switchToOtherPage(2);
          this.$message({
            message: res.msg,
            type: 'error'
          });
        } else {
          this.switchToOtherPage(3);
        }
      });
    },
    changePassword() {
      if (this.isResetCheck) {
        this.$refs.verifyTemplate.refresh();
      }
    },
    logout() {
      this.$confirm('您将登出原有账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 情况所有缓存数据
        sessionStorage.clear();
        this.loading = true;
        this.$ajax({
          prompt: true,
          method: 'POST',
          url: '/account/logout'
        }).then(() => {
          localStorage.removeItem('account');
          localStorage.removeItem('permissions');
          localStorage.removeItem('authorization');
          localStorage.removeItem('internationalVersionFlag');
          localStorage.removeItem('languageSelectOptions');
          localStorage.removeItem('languageSelect');
          setTimeout(() => {
            this.loading = false;
            this.$router.push({ 'path': '/' });
          }, 1000);
        });
      }).then(() => {
        localStorage.removeItem('account');
        localStorage.removeItem('permissions');
        localStorage.removeItem('authorization');
        localStorage.removeItem('internationalVersionFlag');
        localStorage.removeItem('languageSelectOptions');
        localStorage.removeItem('languageSelect');
        this.$router.push({ 'path': '/' });
      });
    },
    timing() {
      setInterval(() => {
        if (this.animatedClass === '') {
          this.animatedClass = 'animated tada custom-classes-transition-enter-to';
        } else {
          this.animatedClass = '';
        }
      }, 1500);
    },
    // 获取验证码
    getVerify() {
      this.$ajax({
        url: '/account/sendVerify',
        data: {
          username: this.username,
          password: this.password
        }
      }).then((res) => {
        if (res.code === 200) {
          this.remainingTime = 60;
          this.startCountdown();
        }
      });
    },
    checkVerify() {
      this.$ajax({
        url: '/account/checkVerify',
        data: {
          username: this.username,
          password: this.password,
          verify: this.authCode
        }
      }).then((res) => {
        if (res.code === 200) {
          localStorage.setItem('authorization', res.data);
          this.userInfo();
        }
      });
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  components: {
    identifyCode, sideVerify, messageBox
  }
};
</script>
<style lang="less" scoped>
.login-page {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(/static/imgs/login_bg.png) repeat;
  .login-wrapper {
    position: absolute;
    padding: 60px 40px;
    left: 50%;
    top: 40%;
    border-radius: 5px;
    background: #49a1f6;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, .18);
    .login-header {
      text-align: center;
      img {
        height: 70px;
      }
    }
    .login-form {
      padding: 15px 0;
      .form-group {
        margin: 15px 0;
        input {
          box-sizing: border-box;
          width: 360px;
          height: 44px;
          padding: 8px;
          font-size: 1.14rem;
          border: 1px solid #ddd;
          &:focus {
            outline: none;
            border-color: #f8b909;
          }
        }
        button {
          box-sizing: border-box;
          width: 360px;
          height: 44px;
          padding: 8px;
          font-size: 1.14rem;
          border: 1px solid #ddd;
          &:focus {
            outline: none;
            border-color: #f8b909;
          }
        }
      }
      .options {
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        a {
          cursor: pointer;
          color: #fee14d;
        }
      }
    }
    .login-footer {
      button {
        width: 360px;
        height: 44px;
        font-size: 1.14rem;
        color: #fff;
        border: none;
        font-weight: 600;
        cursor: pointer;
        background: #4D7CFE;
        &:focus {
          outline: none;
        }
        &:active {
          background: #4D7CFE + 10%;
        }
      }
    }
    .login-check {
      button {
        width: 125px;
        height: 44px;
        font-size: 1.14rem;
        color: #fff;
        border: none;
        font-weight: 600;
        cursor: pointer;
        background: #03b0e0;
        &:focus {
          outline: none;
        }
        &:active {
          background: #4D7CFE + 10%;
        }
      }
    }
    #app {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
      margin-top: 60px;
    }
    .login-form-reset {
      padding: 15px 0;
      .form-group {
        margin: 15px 0;
        input {
          box-sizing: border-box;
          width: 360px;
          /*height: 44px;*/
          padding: 8px;
          font-size: 1.14rem;
          border: 1px solid #ddd;
          &:focus {
            outline: none;
            border-color: #03b0e0;
          }
        }
      }
      .options {
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        a {
          cursor: pointer;
          color: #03b0e0;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/login/index.vue